import { render, staticRenderFns } from "./simplifyContractFee.vue?vue&type=template&id=c58ab798&scoped=true"
import script from "./simplifyContractFee.vue?vue&type=script&lang=js"
export * from "./simplifyContractFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyContractFee.vue?vue&type=style&index=0&id=c58ab798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58ab798",
  null
  
)

export default component.exports